<template>
    <div class="driver-expense-split">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="searchParams.pageNo"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @btnClick="handleBtnClick"
            @adjust-btn="handleAdjustBtn"
            @matchPaymentOrder-btn="handleMatchPaymentOrder"
            moduleCode="driverExpenseSplitLSP"
            searchId="driverExpenseSplitQuery"
            pageID="driverExpenseSplit"
        >
            <div slot="table-top" class="table-module-tips">
                运费支付说明：首先选择发车单执行分账，分账完成后选择发车单发起支付。 注：线下支付（如微信、现金支付）也必须执行分账，分账支付对象选择“其他”，支付对象为“其他”的无需发起支付。
            </div>
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="DRIVER_EXPENSE_SPLIT_EXPORT"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                            <el-button
                                v-has="'driver-expense-split-export'"
                                class="bigData-btn-driver-expense-split-export"
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button
                    v-has="'driver-expense-split-divide'"
                    class="bigData-btn-driver-expense-split-divide"
                    type="primary"
                    :disabled="!selected.length"
                    @click="handleSplitPayment"
                    >分账</el-button
                >
                <el-button
                    v-has="'driver-expense-split-payment'"
                    class="bigData-btn-driver-expense-split-payment"
                    type="primary"
                    :disabled="!selected.length"
                    @click="handleInitiatePayment"
                    >发起支付</el-button
                >
            </div>
        </m-pane>

        <!-- 司机费用分账弹窗 -->
        <split-payment-dialog
            v-if="splitPaymentDialogShow"
            :splitPaymentDialogShow.sync="splitPaymentDialogShow"
            :componentData="selected"
            :divideType="divideType"
            @refresh="refresh"
        ></split-payment-dialog>

        <!-- 发起支付弹窗 -->
        <initiate-payment-dialog
            v-if="initiatePaymentDialogShow"
            :initiatePaymentDialogShow.sync="initiatePaymentDialogShow"
            :componentData="selected"
            :dictData="dictData"
            @changeTab="(val) => $emit('changeTab', val)"
            @refresh="refresh"
        ></initiate-payment-dialog>

        <!-- 匹配支付订单弹窗 -->
        <match-payment-order-dialog
            v-if="matchPaymentOrderDialogShow"
            :matchPaymentOrderDialogShow.sync="matchPaymentOrderDialogShow"
            :componentData="selected"
            @refresh="refresh"
        ></match-payment-order-dialog>
    </div>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import { mapState } from 'vuex';
import { formatSearchData, validateSearchData, formatTotalDataList } from './util.js';
import * as api from '@/modules/transport/otp/api/driverExpenseSplit.js';
import reportExport from '@/components/lots/reportExportPlugin';
import bigDataLog from '@/utils/bigDataLog';
export default {
    name: 'driverExpenseSplit',
    components: {
        mPane,
        reportExport,
        splitPaymentDialog: () => import('./components/splitPaymentDialog.vue'),
        initiatePaymentDialog: () => import('./components/initiatePaymentDialog.vue'),
        matchPaymentOrderDialog: () => import('./components/matchPaymentOrderDialog.vue')
    },
    data () {
        return {
            config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            isFirstSearch: true,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                param: {}
            },
            rowData: {},
            selected: [],
            splitPaymentDialogShow: false,
            initiatePaymentDialogShow: false,
            matchPaymentOrderDialogShow: false,
            divideType: '', // 分账类型：divide-分账，adjust-调整
            dictData: {}
        };
    },
    computed: {
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant,
            supplier: state => state.supplier
        })
    },
    methods: {
        // 选择司机类型
        setConfig() {},
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData);
            // 执行操作
            if (!isQueryOk) return;
            this.searchParams = this.getSearchData(_searchData);
            this.getList();
            this.isFirstSearch = false;
        },
        /**
         * @description 获取列表数据
         * @param {object} 查询条件
         * @return {list} 列表数据
         */
        getList () {
            this.loading = true;
            this.queryCount();
            api.queryPage(this.searchParams)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.totalData = formatTotalDataList(res.data.list || []);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        getSearchData (data) {
            const _searchData = {
                ...this.searchParams,
                pageNo: 1,
                param: {
                    ...data,
                    carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
                }
            };
            return _searchData;
        },
        queryCount () {
            api.queryCount(this.searchParams.param)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data || 0;
                    }
                })
                .catch(() => { });
        },
        /**
         * @description 导出
        */
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchParams.param,
                tenantCode: this.currentTenant.tenantCode,
                beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate: '2030-07-26 00:00:00',
                carrierCodeList: [this.supplier.supplierCode], // 供应商编码-LSP
                requestResults: this.$refs.tablePage.tableList
            });
            this.isFirstSearch = false;
        },
        /*
         * @description 行内按钮触发
         * @param {String} val 当前按钮文本
         * @param {Number} index 当前行索引
         * @param {Object} row 当前行数据
         */
        handleBtnClick (val, index, row, prop) {
            if (prop === 'dispatchNo') {
                this.$router.push({
                    path: `/performance/dispatch-order-detail`,
                    query: {
                        dispatchNo: row.dispatchNo
                    }
                });
            }
        },
        handleAdjustBtn (rowData) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-driver-expense-split-adjust');
            this.selected = [rowData];
            this.divideType = 'adjust';
            this.splitPaymentDialogShow = true;
        },
        handleSplitPayment () {
            if (this.selected.some(item => item.divideStatus !== '0')) {
                return this.$message.warning('仅待分账的订单可操作分账，如需调整分账，请点击“调整”按钮');
            }
            this.divideType = 'divide';
            this.splitPaymentDialogShow = true;
        },
        handleInitiatePayment () {
            if (this.selected.some(item => item.carrierCode !== this.selected[0].carrierCode) ||
                this.selected.some(item => item.payObject !== this.selected[0].payObject || !['2', '3', '4'].includes(item.payObject))
            ) {
                return this.$message({
                    type: 'warning',
                    message: '支付对象必须一致才能批量发起支付',
                    duration: 3000
                })
            }
            if (this.selected.some(item => item.divideStatus !== '1') || this.selected.some(item => !['0', '3'].includes(item.payStatus))
            ) {
                return this.$message({
                    type: 'warning',
                    message: '仅待支付和支付失败的分账单可批量发起支付，请重新选择。如分账单为支付中，请到“支付记录”页面点击“”更新支付状态”按钮更新支付结果',
                    duration: 3000
                })
            }
            if (new Set(this.selected.map(item => item.driver)).size > 500) {
                return this.$message({
                    type: 'warning',
                    message: '单次发起支付最多支持500个不同司机，请重新选择',
                    duration: 3000
                })
            }
            this.initiatePaymentDialogShow = true;
        },
        handleMatchPaymentOrder () {
            this.matchPaymentOrderDialogShow = true;
        },
        // 刷新页面
        refresh (dialogVisible) {
            this[dialogVisible] = false;
            this.getList();
        },
        // 选中表格行
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>
<style lang="less">
.driver-expense-split {
    .table-module-tips {
        margin-bottom: 8px;
        color: #D9001B;
        font-size: 11px;
    }
}
</style>
